import {FormikProps} from 'formik';
import {useState} from 'react';
import ImageCropper from '../../../../../components/ImageCropper';
import {ShowFormError} from '../../../../../utilities/helper/showFormError';
import {IDirectDocsForm} from './formDetails';

interface IProps {
  form: FormikProps<IDirectDocsForm>;
}

const NationalCardField = ({form}: IProps) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const handleCropComplete = (croppedImage: File) => {
    form?.setFieldValue('nationalCardFile', croppedImage);

    // Create preview URL
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setPreviewUrl(fileReader.result as string);
    };
    fileReader.readAsDataURL(croppedImage);
  };

  const handleRemoveImage = () => {
    setPreviewUrl(null);
    if (form) {
      form.setFieldValue('nationalCardFile', null);
    }
  };

  return (
    <div className="mt-3 mb-2">
      <p className="mb-3 font-medium color-gray-1 text-md">
        بارگذاری تصویر کارت ملی<span className="text-red-500">*</span>
      </p>

      <div className="flex">
        {previewUrl ? (
          <div className="relative mb-3">
            <img
              src={previewUrl}
              alt="Invoice Image Preview"
              className="w-20 h-20 object-contain rounded-xl border-[2px] border-dashed"
            />
            <i
              className="absolute left-0 flex items-center justify-center w-6 h-6 text-xl text-red-600 cursor-pointer top-1 icon-nameDelete"
              onClick={handleRemoveImage}
            />
          </div>
        ) : (
          <ImageCropper onCropComplete={handleCropComplete} />
        )}

        <ShowFormError field="nationalCardFile" form={form} />
      </div>
    </div>
  );
};

export default NationalCardField;
